import React from 'react';
import { Form } from '@blueprintnyc/bpnyc-common';
import LinkPicker from 'components/LinkOmniPicker/LinkPicker';
import ImageUpload from 'components/ImageUpload';
import OmniPicker from '@/components/OmniPicker';
import config from 'config';
import WidgetOptionsForm from './WidgetOptionsForm';
import WidgetOptionGroupPermissions from './WidgetOptionGroupPermissions';

const MediaWidgetOptions = props => {
	const {
		event,
		widgetToUpdate,
		handleChange,
		widgetProps,
		setOmniPicker,
		handlePickOmniItem,
		omniPicker,
		handlePickMedia,
		handleGroupChange,
		targetKeys,
	} = props;
	const { onPress } = widgetProps;
	const signedUrlEndpoint = `${config.baseUrl}/${event.client_id}/events/${event.id}/upload/media/signed_url`;

	return (
		<>
			<WidgetOptionsForm initialValues={widgetToUpdate.props} handleChange={handleChange}>
				<Form.Item label="Media Source" name="source">
					<ImageUpload endpoint={signedUrlEndpoint} imageObj={true} />
				</Form.Item>
				<h4 className="admin-form-item-label">Media Link</h4>
				<LinkPicker
					onClick={() => setOmniPicker({ open: true, mediaPicker: false, from: 'link' })}
					onPress={onPress}
					placeholderStr={'Select Link Target'}
					onConfirm={() => handlePickOmniItem({}, 'link')}
				/>
				<WidgetOptionGroupPermissions
					event={event}
					handleGroupChange={handleGroupChange}
					targetKeys={targetKeys}
				/>
			</WidgetOptionsForm>
			<OmniPicker
				event={event}
				visible={omniPicker.open}
				onCancel={() => setOmniPicker({ open: false, mediaPicker: false, from: '' })}
				handlePickItem={handlePickOmniItem}
				handlePickMedia={handlePickMedia}
				mediaPicker={omniPicker.mediaPicker}
				onPress={onPress}
				from={omniPicker.from}
			/>
		</>
	);
};

export default MediaWidgetOptions;
